<template>
  <div id="importExamZIP_Show">
    <ots-main-title :mainTopBtn="mainTopBtn"></ots-main-title>
    
    <div class="mainCon mainBox">
      <div class="descript">
        <p>考试批次：{{info.planName}}</p>
        <p>考点：{{info.placeName}}</p>
        <p>教室：{{info.className}}</p>
        <p>场次：{{info.sessionName}}</p>
      </div>
      <el-form>
        <el-form-item label="提交状态：">
          <el-select v-model="submitOtsAnswer" placeholder="请选择" >
            <el-option label="全部" value=""></el-option>
            <el-option label="提交成功" value="1"></el-option>
            <el-option label="提交失败" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-button type="primary" plain round @click="goBack" style="margin-top: 16px;"> 返回 </el-button>
        <el-button type="primary" round @click="search" style="margin-top: 16px;"> 查询 </el-button>
      </el-form>
    </div>

    <ots-table-group-new
      :tableHeader="tableHeader"
      :tableData="tableData"
      :pagination="pagination"
      @changeNum="changeSize"
      @changePage="changePage"
    ></ots-table-group-new>

  </div>
</template>

<script>
import {queryExamSubmitListAPI, exprotExamSubmitListAPI} from "@/http/modules/computedRoomExam";
//
export default {
  data() {
    return {
      info: {},
      mainTopBtn: [
         {
          title: '导出',
          plain: true,
          fn: this.showExport
        },        
      ],

      tableHeader: [
        {
          title: "姓名",
          prop: "realName",
        },
        {
          title: "准考证号",
          prop: "entranceCode",
        },
        {
          title: "证件号",
          prop: "cardNo",
        },
        {
          title: "教学点",
          prop: "stationName",
        },
        {
          title: "座位号",
          prop: "seatNo",
        },
        {
          title: "提交时间",
          prop: "submitOtsDate"
        },
        {
          title: "提交状态",
          prop: "submitOtsAnswer",
        },
        {
          title: "备注",
          prop: "submitOtsRemark",
          type: "tag_Z",
          tagColor: (scope) => {
            if (scope.row.submitOtsAnswer !== "提交成功") {
              return "col_red"
            }
          },
          width: "280"
        }
      ],
      tableData: [

      ],
      pagination: {
        total: 0,
      },
      page: 1,
      size: 10,
      submitOtsAnswer: "",
    }
  },
  methods: {
    search() {
      this.page = 1;
      this.getTableList();
    },
    async getTableList() {
      let { planId, classId, placeId, sessionId } = this.$route.query;
      let params = {
        planId,
        classId,
        placeId,
        sessionId,
        size: this.size,
        page: this.page,
        submitOtsAnswer: this.submitOtsAnswer
      }
      const { code, data } = await queryExamSubmitListAPI(params);
      if (code) {
        this.tableData = data.records;
        this.pagination.total = data.total;
      }
    },
    async showExport() {
      let { sessionId, planId, placeId, classId } = this.$route.query;
      let params = {
        sessionId, planId, placeId, classId,
        submitOtsAnswe: this.submitOtsAnswe,
        // page: this.page,
        // size: this.size,
      }
      const { code, data } = await exprotExamSubmitListAPI(params);
      if (code) {
        window.open(data);
      }
    },
    changeSize(num) {
      this.size = num;
      this.getTableList();
    },
    changePage(p) {
      this.page = p;
      this.getTableList();
    },
    goBack() {
      window.history.go(-1); 
    },
  },
  created() {
    this.info = this.$route.query;
    this.search();
  }

}
</script>

<style lang="less" scoped>
.default-upload-container {
  box-sizing: border-box;
  width: 240px;
  height: 36px;
  border-radius: 4px;
  border: 1px solid #dddddd;
  background: rgba(255, 255, 255, 0.35);
  color: #c2c4cc;
  font-size: 13px;
  line-height: 36px;
  text-align: left;
  padding-left: 12px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.descript {
  display: flex;
  &>p {
    margin-right: 36px;
  }
  margin-bottom: 16px;
}
</style>